import global from "global";
import shouldLogWithNewRelic from "./shouldLogWithNewRelic";

export default (level, detail, attributes) => {
  if (shouldLogWithNewRelic(level)) {
    global.newrelic.noticeError(detail, attributes);
  }
};
